<app-loader
  [isActive]="this.isLoading$ | async"
  [enableCircle]="true"
  [isAfterViewInit]="false"
  [width]="20"
></app-loader>
<div matDialogTitle fxLayoutAlign="start center" class="mt-3 mb-2">
  <span>{{ 'workspace.plural' | translate }}</span>
  <div fxFlex></div>
  <button *ngIf="!this.isLoading" mat-icon-button matDialogClose tabindex="-1">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content fxLayout="column" fxLayoutGap="8px" class="mat-dialog-flex-content">
  <mat-form-field
    appearance="fill"
    class="mt-2 pb-0 mat-form-field-no-hint mat-form-field-compact mat-form-field-plain"
  >
    <input type="text" matInput [formControl]="this.nameInput" [placeholder]="'utils.search' | translate" />
  </mat-form-field>
  <ng-container *ngIf="this.workspace$filtered | async as ws">
    <ng-container *ngIf="ws.length > 0; else noitemno">
      <div class="scroll-auto -mx-24px px-24px pt-1 pb-24px">
        <div gdArea gdColumns="1fr" gdColumns.gt-xs="1fr 1fr" gdColumns.gt-md="1fr 1fr 1fr" gdGap="16px">
          <ng-container *ngFor="let item of ws; trackBy: trackId">
            <div
              class="workspace-card cursor-pointer pos-relative"
              matRipple
              (click)="!item.selected && this.changeWorkspace(item)"
              [class.workspace-card-active]="item.selected"
              [matTooltip]="item.name"
              [matTooltipDisabled]="mobileWorkspaceName ? item.name.length < 50 : item.name.length < 20"
            >
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                <div fxLayout="column">
                  <strong>{{ item.name | truncate: 24 }}</strong>
                  <div class="mat-hint">{{ item.description | truncate: 50 }}</div>
                </div>
              </div>
              <div fxFlex></div>
              <div class="workspace-card-users">
                <div class="workspace-card-user workspace-card-user-shift" *ngIf="item.users.length > 5">
                  <div class="workspace-card-user-image workspace-card-user-image-default">
                    +{{ item.users.length - 5 | clamp: 0:9 }}
                  </div>
                </div>
                <div
                  class="workspace-card-user"
                  [class.workspace-card-user-shift]="!last"
                  *ngFor="let user of item.users | slice: 0:5; let first = first; let last = last; trackBy: trackId"
                >
                  <app-user-avatar
                    size="24px"
                    class="workspace-card-user-image"
                    [userId]="user.id"
                    matTooltip
                    [matTooltipTemplate]="userHoverCard"
                    [matTooltipTemplateContext]="{ user: user }"
                    defaultImageSource="/assets/img/default.png"
                  ></app-user-avatar>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-template #noitemno>
      <p class="text-center mat-hint">{{ 'errors.empty' | translate }}</p>
    </ng-template>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions class="mat-action-filled" fxFlex="0 0 auto">
  <button mat-flat-button class="mat-action-filled" color="primary" (click)="this.openCreateDialog()">
    {{ 'workspace.create' | translate }}
  </button>
</mat-dialog-actions>
<ng-template #userHoverCard let-user="user">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="-mx-1">
    <app-user-avatar
      size="40px"
      class="rounded-xs"
      [userId]="user.id"
      matTooltip
      [matTooltipTemplate]=""
      defaultImageSource="/assets/img/default.png"
    ></app-user-avatar>
    <div fxLayout="column" class="mat-typography">
      <div>{{ user.name }}</div>
      <div class="mat-hint">{{ user.email | truncate: 42 }}</div>
    </div>
  </div>
</ng-template>
